export const buildHotelDetailURL = (args, hotel) => {
  var _a, _b;
  const isExpressDeal = hotel.hotelType === 'SOPQ';
  const hotetIdParams = isExpressDeal ? `express/${(_a = hotel.location) === null || _a === void 0 ? void 0 : _a.cityId}/${hotel.pclnId}` : hotel.hotelId;
  let urlWithoutChild = `/relax/at/${hotetIdParams}/from/${args === null || args === void 0 ? void 0 : args['check-in']}/to/${args === null || args === void 0 ? void 0 : args['check-out']}/rooms/${args === null || args === void 0 ? void 0 : args.rooms}/adults/${args === null || args === void 0 ? void 0 : args['adult-occ']}`;
  if (args === null || args === void 0 ? void 0 : args['child-occ']) {
    const childOcc = args === null || args === void 0 ? void 0 : args['child-occ'];
    const childPathParams = (_b = childOcc.split(',').reduce((res, child) => {
      var _a;
      const age = (_a = child === null || child === void 0 ? void 0 : child.split('-')) === null || _a === void 0 ? void 0 : _a[1];
      if (age) {
        res.push(age);
      }
      return res;
    }, [])) === null || _b === void 0 ? void 0 : _b.join(',');
    if (childPathParams) {
      urlWithoutChild += `/children/${childPathParams}`;
    }
  }
  return urlWithoutChild;
};